// pages/ProformaGeneratorPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Space, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ProformaGenerator from '../components/Orders/ProformaGenerator';
import api from '../services/api';

const ProformaGeneratorPage = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    // Fetch orders and customers
    const fetchData = async () => {
      try {
        const [ordersData, customersData] = await Promise.all([
          api.get('/orders'),
          api.get('/customers')
        ]);

        const allOrders = ordersData.data || [];
        const installedOrders = allOrders.filter(o => o.installationCompleted === true);
        setOrders(installedOrders);
        setCustomers(customersData.data || []);
      } catch (error) {
        message.error('Failed to load data');
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/msedcl')}
          >
            Back to MSEDCL Dashboard
          </Button>

          <ProformaGenerator
            visible={true}
            onCancel={() => navigate('/msedcl')}
            orders={orders}
            customers={customers}
          />
        </Space>
      </Card>
    </div>
  );
};

export default ProformaGeneratorPage;